import { useRouter } from "next/router"
import { getTutuModelsUrl, TutuModelVideo } from "@jconradi/tutu-porn-components/services/api/tutu-models/tutu-models"
import VerifiedIcon from '../../../public/images/icons/verified.svg';
import useTranslation from "next-translate/useTranslation";
import { useInView } from "react-intersection-observer";
import cls from 'clsx';
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

export const TutuMediaListItem = ({ video }: { video: TutuModelVideo }) => {
    const router = useRouter();
    const { t } = useTranslation("common");
    const [loading, setLoading] = useState(true);

    const { width, height } = video.videoInformation;
    const { ref: mediaViewRef, inView: inMediaView } = useInView({
        triggerOnce: false,
        threshold: 1,
        rootMargin: '1000px 0px',
    });

    return (
        <>
            <a href={getTutuModelsUrl(`/videos/${video.slug}`, router.locale)} ref={mediaViewRef} style={{
                aspectRatio: `${width} / ${height}`
            }} className={cls("w-full bg-base-300 mx-auto rounded-2xl relative overflow-hidden", {
                ['max-w-[480px]']: video.videoInformation.height > video.videoInformation.width
            })}>
                {inMediaView &&
                    <>
                        <video src={video.trailerUrl} onLoadStart={() => setLoading(true)} onLoadedData={() => setLoading(false)}
                            autoPlay playsInline loop muted preload="none" className="ring-primary ring-2 rounded-2xl w-full h-full" />
                        {loading && <Skeleton className="absolute inset-0 z-0" />}
                    </>
                }
            </a>
            <p className="text-xs text-center my-1 flex flex-row gap-x-1 items-center justify-center -my-6 w-full">
                <VerifiedIcon className="w-4 h-4" />
                {t('tutuModels')}</p>
        </>
    )
}